import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

/** Account presentation only; the shell retains its existing sign-out action. */
@Component({
  selector: 'app-account-menu',
  standalone: true,
  imports: [CommonModule, MatMenuModule],
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss']
})
export class AccountMenuComponent {
  @Input() userName = '';
  @Input() compact = false;
  @Output() signedOut = new EventEmitter<void>();
  @HostBinding('class.ia-account-menu--mobile') get mobile(): boolean { return this.compact; }
  @HostBinding('class.ia-account-menu--desktop') get desktop(): boolean { return !this.compact; }

  get initials(): string {
    const words = (this.userName || '').trim().split(/\s+/).filter(Boolean);
    return words.length ? (words[0].charAt(0) + (words.length > 1 ? words[words.length - 1].charAt(0) : '')).toUpperCase() : 'U';
  }
}
